module.exports = __webpack_public_path__ + "img/videos_trainings.680db844.png";